/* Sticky Add to Cart, below-the-fold case. 2026-10-21 (Sarah).
   gd.js shows .atcbar only once the real button has scrolled off the TOP
   (rect.bottom < 0). A tall 4:5 bottle photo can push the real button below
   the fold on a phone, and then nothing to buy with is on screen at all.
   This shows the bar whenever the real button is out of view in EITHER
   direction. It loads after gd.js, so on every scroll its listener runs
   second and has the last word; gd.js itself is untouched.
   .atcbar is display:none on desktop (gd-fix.css), so this is phone-only
   in effect. One line in theme.liquid to revert. */
(function () {
  'use strict';
  var anchor = document.querySelector('[data-atc-anchor]');
  var bar = document.querySelector('.atcbar');
  if (!anchor || !bar) return;
  var sync = function () {
    var r = anchor.getBoundingClientRect();
    bar.classList.toggle('on', r.bottom < 0 || r.top > window.innerHeight);
  };
  window.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync, { passive: true });
  sync();
})();

/* Swipe gallery, 2026-10-21 (Sarah, Brittany's ask). Markup in main-product.liquid.
   The track is a native scroll-snap row, so the swipe itself is the browser's own;
   this only keeps the thumbs, dots and arrows in step with it, and plays the video
   while its slide is showing. gd.js's thumb handler is a no-op on these thumbs
   (no data-src, no data-gvid), so nothing here fights it. */
(function () {
  'use strict';
  var slider = document.querySelector('[data-gslider]');
  var track = slider && slider.querySelector('[data-gtrack]');
  if (!track) return;
  var slides = track.querySelectorAll('.gslide');
  var n = slides.length;
  if (n < 2) return;
  var thumbs = document.querySelectorAll('.thumbs .thumb[data-slide]');
  var dots = slider.querySelectorAll('.gdot');
  var prev = slider.querySelector('[data-gprev]');
  var next = slider.querySelector('[data-gnext]');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cur = -1;

  var go = function (i) {
    i = Math.max(0, Math.min(n - 1, i));
    track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
  };
  var set = function (i) {
    if (i === cur) return;
    cur = i;
    Array.prototype.forEach.call(thumbs, function (t, k) { t.classList.toggle('on', k === i); });
    Array.prototype.forEach.call(dots, function (d, k) { d.classList.toggle('on', k === i); });
    if (prev) prev.disabled = i === 0;
    if (next) next.disabled = i === n - 1;
    Array.prototype.forEach.call(slides, function (s, k) {
      var v = s.querySelector('video');
      if (!v) return;
      if (k === i) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); }
    });
    /* Keep the active thumb in view when the strip itself scrolls. */
    var th = thumbs[i], row = th && th.parentNode;
    if (row && row.scrollWidth > row.clientWidth) {
      row.scrollTo({ left: th.offsetLeft - (row.clientWidth - th.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' });
    } else if (row && row.scrollHeight > row.clientHeight) {
      /* Bottle pages on desktop: the strip is a COLUMN (rev 4). */
      row.scrollTo({ top: th.offsetTop - (row.clientHeight - th.offsetHeight) / 2, behavior: reduce ? 'auto' : 'smooth' });
    }
  };

  var raf = 0;
  track.addEventListener('scroll', function () {
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = 0;
      set(Math.round(track.scrollLeft / Math.max(1, track.clientWidth)));
    });
  }, { passive: true });
  Array.prototype.forEach.call(thumbs, function (t) {
    t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-slide'), 10)); });
  });
  if (prev) prev.addEventListener('click', function () { go(cur - 1); });
  if (next) next.addEventListener('click', function () { go(cur + 1); });
  track.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
  });
  /* A resize changes the slide width; snap back onto the current slide. */
  window.addEventListener('resize', function () { track.scrollLeft = cur * track.clientWidth; }, { passive: true });

  /* Desktop thumb COLUMN (rev 4): cap it to the photo's height so it ends where
     the photo ends and scrolls inside that. On a phone the strip is a row and
     this clears the cap. */
  var row = thumbs.length && thumbs[0].parentNode;
  var desk = window.matchMedia('(min-width: 769px)');
  var fit = function () {
    if (!row) return;
    row.style.maxHeight = desk.matches ? slider.getBoundingClientRect().height + 'px' : '';
  };
  window.addEventListener('resize', fit, { passive: true });
  window.addEventListener('load', fit);
  fit();
  set(0);
})();

/* Click to zoom, 2026-10-21 rev 4 (Sarah, Brittany: desktop photos looked small).
   Click or tap any gallery photo: it opens full screen at 2400px (the same Shopify
   CDN image with its width parameter raised, so no new markup is needed). Click
   again to magnify 2.5x at that point; move the mouse, or drag a finger, to look
   around. Arrows, arrow keys or a swipe step between photos; Esc, the X or a tap
   on the dark ground closes it and returns focus to where it was. Videos are not
   zoomable and keep their own controls.
   Rev 5 (Brittany): scroll flips photos; flipping keeps the magnification; phones
   get arrows while magnified (a finger drag pans there, so swipe cannot flip). */
(function () {
  'use strict';
  var imgs = Array.prototype.slice.call(document.querySelectorAll('.gslide img.gzoomable'));
  if (!imgs.length) return;
  var big = function (im) {
    var s = im.currentSrc || im.src;
    return /[?&]width=\d+/.test(s) ? s.replace(/([?&]width=)\d+/, function (m, p) { return p + '2400'; }) : s + (s.indexOf('?') < 0 ? '?' : '&') + 'width=2400';
  };
  var box = document.createElement('div');
  box.className = 'gzbox';
  box.setAttribute('role', 'dialog');
  box.setAttribute('aria-modal', 'true');
  box.setAttribute('aria-label', 'Product photo, full screen');
  box.innerHTML = '<div class="gzstage"><img class="gzimg" alt=""></div>' +
    '<button class="gzbtn gzx" type="button" aria-label="Close">&times;</button>' +
    '<button class="gzbtn gzp" type="button" aria-label="Previous photo">&#8249;</button>' +
    '<button class="gzbtn gzn" type="button" aria-label="Next photo">&#8250;</button>' +
    '<div class="gzc" aria-live="polite"></div>';
  document.body.appendChild(box);
  var stage = box.querySelector('.gzstage'), zi = box.querySelector('.gzimg');
  var bx = box.querySelector('.gzx'), bp = box.querySelector('.gzp'), bn = box.querySelector('.gzn');
  var cnt = box.querySelector('.gzc');
  var cur = 0, zoomed = false, back = null;

  var origin = function (x, y) {
    var r = zi.getBoundingClientRect();
    var px = Math.max(0, Math.min(100, (x - r.left) / r.width * 100));
    var py = Math.max(0, Math.min(100, (y - r.top) / r.height * 100));
    zi.style.transformOrigin = px + '% ' + py + '%';
  };
  var unzoom = function () { zoomed = false; box.classList.remove('zoomed'); zi.style.transform = ''; };
  /* keep: flip while magnified (rev 5). The next photo opens magnified at the
     same spot instead of snapping back to the full view. */
  var show = function (i, keep) {
    cur = (i + imgs.length) % imgs.length;
    if (!keep) unzoom();
    zi.src = big(imgs[cur]);
    zi.alt = imgs[cur].alt || '';
    bp.disabled = bn.disabled = imgs.length < 2;
    cnt.textContent = imgs.length > 1 ? (cur + 1) + ' / ' + imgs.length : '';
  };
  var open = function (i) {
    back = document.activeElement;
    show(i);
    box.classList.add('on');
    document.body.classList.add('gz-open');
    bx.focus();
  };
  var close = function () {
    box.classList.remove('on');
    document.body.classList.remove('gz-open');
    unzoom();
    if (back && back.focus) back.focus();
  };

  imgs.forEach(function (im, i) {
    im.addEventListener('click', function () { open(i); });
  });
  bx.addEventListener('click', close);
  bp.addEventListener('click', function () { show(cur - 1, zoomed); });
  bn.addEventListener('click', function () { show(cur + 1, zoomed); });
  stage.addEventListener('click', function (e) { if (e.target === stage) close(); });
  zi.addEventListener('click', function (e) {
    if (moved) { moved = false; return; }
    if (zoomed) { unzoom(); return; }
    origin(e.clientX, e.clientY);
    zoomed = true;
    box.classList.add('zoomed');
    zi.style.transform = 'scale(2.5)';
  });
  zi.addEventListener('mousemove', function (e) { if (zoomed) origin(e.clientX, e.clientY); });
  document.addEventListener('keydown', function (e) {
    if (!box.classList.contains('on')) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowRight') show(cur + 1, zoomed);
    else if (e.key === 'ArrowLeft') show(cur - 1, zoomed);
  });

  /* Rev 5: a mouse wheel or a two-finger trackpad swipe flips photos, sideways or
     up/down, magnified or not. One gesture = one photo: a trackpad keeps firing
     wheel events through its momentum, so after a flip the wheel stays locked until
     the events stop for 250ms. preventDefault keeps the page behind from moving. */
  var wAcc = 0, wLock = false, wQuiet = 0;
  box.addEventListener('wheel', function (e) {
    if (!box.classList.contains('on')) return;
    e.preventDefault();
    clearTimeout(wQuiet);
    wQuiet = setTimeout(function () { wLock = false; wAcc = 0; }, 250);
    if (wLock || imgs.length < 2) return;
    wAcc += Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
    if (Math.abs(wAcc) > 40) {
      wLock = true;
      show(cur + (wAcc > 0 ? 1 : -1), zoomed);
      wAcc = 0;
    }
  }, { passive: false });
  /* Touch: drag to look around while magnified, swipe to change photo otherwise. */
  var sx = 0, sy = 0, moved = false;
  zi.addEventListener('touchstart', function (e) {
    var t = e.touches[0]; sx = t.clientX; sy = t.clientY; moved = false;
  }, { passive: true });
  zi.addEventListener('touchmove', function (e) {
    var t = e.touches[0];
    if (zoomed) { origin(t.clientX, t.clientY); moved = true; }
  }, { passive: true });
  zi.addEventListener('touchend', function (e) {
    if (zoomed) return;
    var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
    if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
      moved = true;
      show(cur + (dx < 0 ? 1 : -1));
    }
  }, { passive: true });
})();
